import { rem } from 'polished';
var theme = {
  icon: {
    size: {
      xxxlg: rem('64px'),
      xxlg: rem('56px'),
      xlg: rem('48px'),
      lg: rem('40px'),
      md: rem('32px'),
      sm: rem('24px')
    }
  }
};
export default theme;